import React from 'react';
import PropTypes from 'prop-types';
import { I18nText } from '@welldev-group/react-comp-lib';
import Card from '@welldev-group/rcl-card';
import newsIcon from 'affiliateIcons/newspaper.svg';
import NewsCard from './NewsCard';

const NewsBody = ({ newsList, newsCategory }) => {
  const isNewsAvailable = newsList.length > 0;

  const generateKey = id => {
    return `${newsCategory}-${id}`;
  };

  return isNewsAvailable ? (
    <>
      {newsList.map(news => (
        <NewsCard
          key={generateKey(news.id)}
          newsLink={news.url}
          teaser={news.teaser}
          imageUrl={news.image_urls.small}
          author={news.author}
          createdAt={news.created_at}
        />
      ))}
    </>
  ) : (
    <div className="col-12">
      <Card version="v2" className="news-body__empty-card">
        <div className="grid">
          <div className="col-12">
            <div className="col-grid news-body">
              <div className="news-body__icon">
                <img src={newsIcon} alt="credit-card" />
              </div>
              <div className="news-body__empty-text">
                <I18nText id="dashboard.news.empty" />
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

NewsBody.propTypes = {
  newsList: PropTypes.PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      teaser: PropTypes.string,
      image_url: PropTypes.shape({
        small: PropTypes.string,
        medium: PropTypes.string,
        large: PropTypes.string,
      }),
      url: PropTypes.string,
    }),
  ).isRequired,
  newsCategory: PropTypes.string.isRequired,
};

export default NewsBody;
